<template>
  <b-nav vertical class="flex-nowrap">
    <b-nav-item id="sidebar-dashboard" v-if="permissions.includes('dashboard')" :to="{name: 'Dashboard'}">
      <div class="nav-link-icon"><i class="fas fa-heartbeat"/></div>
      Dashboard
    </b-nav-item>
    <b-nav-item-dropdown
        v-if="permissions.some(p => [
            'attributes.index',
            'credentials.index',
            'fileformats.index',
            'functions.index',
            'integrationhelper.index',
            'integrations.index',
            'manufactures.index',
            'protocols.index',
            'protocol_settings.index',
            'states.index',
            'vns.index',
            'report_trash.index',
            'report_control.index',
            'report_editable.index',
        ].indexOf(p) >= 0)"
        id="vns-dropdown" menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fa fa-compact-disc"/></div>
        VNS
        <i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item
            v-if="permissions.includes('integrations.index')"
            id="sidebar-vns"
            :to="{ name: 'vns.index'}">
          {{ $t('sideBar.listagem') }}
        </b-dropdown-item>        
        <b-dropdown-item
            v-if="permissions.includes('integrations.index')"
            id="sidebar-integracoes"
            :to="{ name: 'vns.integration'}">
          {{ $t('sideBar.integracoes.label') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('credentials.index')"
            id="sidebar-credenciais"
            :to="{ name: 'vns.credential'}">
          {{ $t('sideBar.integracoes.credenciais') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('fileformats.index')"
            id="sidebar-arquivos"
            :to="{name: 'vns.fileformat'}">
          {{ $t('sideBar.integracoes.formatos_arquivos') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('protocols.index')"
            id="sidebar-protocolos"
            :to="{name: 'vns.protocol'}">
          {{ $t('sideBar.integracoes.protocolos') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('protocol_settings.index')"
            id="sidebar-configuracao_protocolo"
            :to="{name: 'vns.protocol_settings'}">
          {{ $t('sideBar.integracoes.configuracao_protocolo') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="permissions.includes('functions.index')" id="sidebar-cloudfunctions" :to="{ name: 'functions'}">
          CloudFunctions
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('manufactures.index')"
            id="sidebar-fabricantes"
            :to="{name: 'vns.manufacturer'}">
          {{ $t('sideBar.integracoes.fabricante') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('states.index')"
            id="sidebar-estados"
            :to="{name: 'vns.states'}">
          {{ $t('sideBar.integracoes.estados') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('integrationhelper.index')"
            id="sidebar-integrationhelper"
            :to="{name: 'vns.integration_helper'}">
          {{ $t('sideBar.integracoes.integration_helper') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('attributes.index')"
            id="sidebar-atributos"
            :to="{name: 'vns.attribute'}">
          {{ $t('sideBar.integracoes.atributos') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('report_trash.index')"
            id="sidebar-resultados-descartaveis"
            :to="{ name: 'vns.report_trash'}">
          {{ $t('sideBar.integracoes.resultados_descartaveis') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('report_control.index')"
            id="sidebar-resultados-controle-descartaveis"
            :to="{ name: 'vns.report_control'}">
          {{ $t('sideBar.integracoes.resultados_controle_descartaveis') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('report_editable.index')"
            id="sidebar-resultados-editaveis"
            :to="{ name: 'vns.report_editable'}">
          {{ $t('sideBar.integracoes.resultados_editaveis') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p => [
                    'vns_monitor.tipo',
                    'vns_monitor.observation',
                    'vns_monitor.observation_support',
                    'vns_monitor.observation_lis',
                    'container_support.index',
                    'review_observation.index',
                ].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-video"/></div>
        {{ $t('sideBar.monitores.label') }}
        <i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item
            v-if="permissions.includes('vns_monitor.tipo')"
            id="sidebar-monitor-vns-tipo"
            :to="{ name: 'vns.monitoring'}">
          {{ $t('sideBar.monitores.tipo') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('vns_monitor.service_queue')"
            id="sidebar-monitor-vns-service_queue"
            :to="{ name: 'vns.service_queue'}">
          {{ $t('sideBar.monitores.fila_atendimento') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('vns_monitor.observation')"
            id="sidebar-monitor-order_obs"
            :to="{ name: 'monitoring.order.observation'}">
          {{ $t('sideBar.monitores.ordem_resultado') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('vns_monitor.observation_support')"
            id="sidebar-monitor-order_obs-apoio"
            :to="{ name: 'monitoring.order.observation_support'}">
          {{ $t('sideBar.monitores.ordem_resultado_apoio') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('vns_monitor.observation_lis')"
            id="sidebar-monitor-order_obs-lis"
            :to="{ name: 'monitoring.order.observation_lis'}">
          {{ $t('sideBar.monitores.ordem_resultado_lis') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('container_support.index')"
            id="sidebar-monitor-vns-detail"
            :to="{ name: 'container_support.index'}">
          {{ $t('sideBar.monitores.etiquetas_apoio') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('review_observation.index')"
            id="sidebar-review-observation"
            :to="{ name: 'review_observation.index'}">
          {{ $t('sideBar.monitores.revisar_resultado') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p =>[
                    'components.index',
                    'tuevs_exams.index',
                    'materials.index',
                    'complements.index',
                    'methods.index',
                    'scales.index',
                    'times.index',
                    'examresult.index'
                ].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-table"/></div>
        {{ $t('sideBar.tuevs.label') }}
        <i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item
            v-if="permissions.includes('tuevs_exams.index')"
            id="sidebar-tuevs-exames"
            :to="{ name: 'tuevs.exams'}">
          {{ $t('sideBar.tuevs.exames') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('tuevs_exams.index')"
            id="sidebar-tuevs-exames_bulk"
            :to="{ name: 'tuevs.exams_bulk'}">
          {{ $t('sideBar.tuevs.exames') + ' Bulk' }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('components.index')"
            id="sidebar-tuevs-componenetes"
            :to="{ name: 'tuevs.component'}">
          {{ $t('sideBar.tuevs.componentes') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('materials.index')"
            id="sidebar-tuevs-materiais"
            :to="{ name: 'tuevs.material'}">
          {{ $t('sideBar.tuevs.materiais') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('complements.index')"
            id="sidebar-complements-materiais"
            :to="{ name: 'tuevs.complements'}">
          {{ $t('sideBar.tuevs.complements') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('methods.index')"
            id="sidebar-tuevs-metodos"
            :to="{ name: 'tuevs.method'}">
          {{ $t('sideBar.tuevs.metodos') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('scales.index')"
            id="sidebar-tuevs-escalas"
            :to="{ name: 'tuevs.scale'}">
          {{ $t('sideBar.tuevs.escalas') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('times.index')"
            id="sidebar-tuevs-tempos"
            :to="{ name: 'tuevs.time'}">
          {{ $t('sideBar.tuevs.tempos') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('examresult.index')"
            id="sidebar-tuevs-valor-resultados"
            :to="{ name: 'tuevs.examresult'}">
          {{ $t('sideBar.tuevs.examresult') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.includes('loincs.index')"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-capsules"/></div>
        {{ $t('sideBar.loinc.label') }}
        <i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item v-if="permissions.includes('loincs.index')" id="sidebar-loinc" :to="{ name: 'loinc.index'}">
          {{ $t('sideBar.loinc.listagem') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="perfil === 'root'" id="sidebar-loinc-csv" :to="{name: 'loinc.import.csv'}">
          {{ $t('sideBar.loinc.importar_csv') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="perfil === 'root'" id="sidebar-loinc-csv-lang" :to="{name: 'loinc.import.csv.traducao'}">
          {{ $t('sideBar.loinc.importar_traducoes') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p => [
                    'dexpara.ordem',
                    'dexpara.resulado',
                    'dexpara.metodo',
                    'dexpara.material',
                    'dexpara.complement',
                    'dexpara.exame.resultado',
                    'dexpara.tipo',
                    'tipo',
                    'resultrange',
                    'resultconversion',
                ].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-random"/></div>
        {{ $t('sideBar.dexpara.label') }}
        <i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item
            v-if="permissions.includes('dexpara.ordem')"
            id="sidebar-dexpara-ordem"
            :to="{ name: 'dexpara.ordem'}">
          {{ $t('sideBar.dexpara.ordem') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('dexpara.resultado')"
            id="sidebar-dexpara-resultado"
            :to="{name: 'dexpara.resultado'}">
          <span>{{ $t('sideBar.dexpara.resultado') }}</span>
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('dexpara.material')"
            id="sidebar-dexpara-material"
            :to="{ name: 'dexpara.material'}">
          {{ $t('sideBar.dexpara.materiais') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('dexpara.complement')"
            id="sidebar-dexpara-complement"
            :to="{ name: 'dexpara.complement'}">
          {{ $t('sideBar.dexpara.complements') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('dexpara.metodo')"
            id="sidebar-dexpara-metodo"
            :to="{name: 'dexpara.metodo'}">
          {{ $t('sideBar.dexpara.metodos') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('dexpara.exame.resultado')"
            id="sidebar-dexpara-exame-resultado"
            :to="{name: 'dexpara.exame.resultado'}">
          {{ $t('sideBar.dexpara.exame_resultado') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('dexpara.tipo')"
            id="sidebar-dexpara-tipo"
            :to="{name: 'dexpara.tipo'}">
          {{ $t('sideBar.dexpara.tipo') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('tipo')"
            id="sidebar-dexpara-tipo-create"
            :to="{name: 'tipo'}">
          {{ $t('sideBar.dexpara.tipo_create') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('resultrange')"
            id="sidebar-dexpara-result-range-create"
            :to="{name: 'resultrange'}">
          {{ $t('sideBar.dexpara.result_range_create') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('resultconversion')"
            id="sidebar-dexpara-result-conversion-create"
            :to="{name: 'resultconversion'}">
          {{ $t('sideBar.dexpara.result_conversion_create') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p=> [
                    'triggers.index',
                    'ranges.index',
                    'vns_permissions.index',
                ].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-users-cog"/></div>
        {{ $t('sideBar.equipamentos.label') }}
        <i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item
            v-if="permissions.includes('triggers.index')"
            id="sidebar-equipment-triggers"
            :to="{ name: 'trigger.index' }">
          {{ $t('sideBar.triggers') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('ranges.index')"
            id="sidebar-equipment-ranges"
            :to="{ name: 'vns.ranges'}">
          {{ $t('sideBar.equipamentos.ranges') }}
        </b-dropdown-item>
        <b-dropdown-item
            v-if="permissions.includes('vns_permissions.index')"
            id="sidebar-equipment-permissoes"
            :to="{ name: 'vns.permissions.index' }">
          {{ $t('sideBar.equipamentos.permissoes') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p => ['rnds.index', 'rnds.create'].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-broadcast-tower"/></div>
        RNDS<i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item v-if="permissions.includes('rnds.index')" id="sidebar-rnds-index" :to="{ name: 'rnds.index'}">
          {{ $t('sideBar.rnds.listar') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="permissions.includes('rnds.create')" id="sidebar-rnds-create" :to="{ name: 'rnds.create'}">
          {{ $t('sideBar.rnds.transmitir') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p => ['interopera.create'].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-broadcast-tower"/></div>
        Interopera<i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item v-if="permissions.includes('rnds.index')" id="sidebar-rnds-index" :to="{ name: 'rnds.index'}">
          {{ $t('sideBar.rnds.listar') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="permissions.includes('interopera.create')" id="sidebar-interopera-create" :to="{ name: 'interopera.create'}">
          {{ $t('sideBar.interopera.transmitir') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p => ['corecompanies.index', 'corecareunits.index'].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-broadcast-tower"/></div>
        {{ $t('sideBar.core.label') }}<i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item v-if="permissions.includes('corecompanies.index')" id="core-company-index" :to="{ name: 'corecompanies.index'}">
          {{ $t('sideBar.core.companies') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="permissions.includes('corecareunits.index')" id="core-careunits-index" :to="{ name: 'corecareunits.index'}">
          {{ $t('sideBar.core.careunits') }}
        </b-dropdown-item>
        <b-dropdown-item v-if="permissions.includes('coresectors.index')" id="core-sectors-index" :to="{ name: 'coresectors.index'}">
          {{ $t('sideBar.core.sector') }}
        </b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
        v-if="permissions.some(p => ['logs.index'].indexOf(p) >= 0)"
        menu-class="bg-transparent border-0 p-0 ml-4 position-relative" no-caret>
      <template v-slot:button-content>
        <div class="nav-link-icon"><i class="fas fa-broadcast-tower"/></div>
        {{ $t('sideBar.auditoria.label') }}<i class="fa fa-chevron-down ml-auto"/>
      </template>
      <b-dropdown-group class="d-flex flex-column position-relative">
        <b-dropdown-item v-if="permissions.includes('logs.index')" id="logs-index" :to="{ name: 'logs.index'}">
          {{ $t('sideBar.auditoria.logs') }}
        </b-dropdown-item>        
      </b-dropdown-group>
    </b-nav-item-dropdown>    
    <b-nav-item class="nav-tabs" disabled/>

    <b-nav-item>
      <div class="main-vaa">
        <div class="flags">
          <div style="text-align: center;">
            <span>{{ $t('sideBar.language.select') }}:</span>
          </div>
          <b-button @click="changeLanguage('pt_BR')" variant="link">
            <img src="@/assets/img/auto_atendimento/brazil-square.png" width="30" alt="Bandeira do Brasil">
          </b-button>
          <b-button @click="changeLanguage('es')" variant="link">
            <img src="@/assets/img/auto_atendimento/spain-square.png" width="30" alt="Bandera Española">
          </b-button>
          <b-button @click="changeLanguage('en')" variant="link">
            <img src="@/assets/img/auto_atendimento/eua-square.png" width="30" alt="United States Flag">
          </b-button>
        </div>
        <div class="container text-gray">
          <router-view />
        </div>
      </div>
    </b-nav-item>
    
    <b-nav-item :href="VeusUrl">
      <b-btn variant="outline-primary" block>Voltar ao Veus Saúde</b-btn>
    </b-nav-item>
  </b-nav>
</template>

<script>
import {getPerfil, getPermissionsFromActualPerfil} from '@/acl';
import {VS_URL} from '@/providers/EnvironmentProvider';
import Cookies from 'js-cookie';

export default {
  name: 'SideBar',
  computed: {
    VeusUrl() {
      return VS_URL
    }
  },
  data() {
    return {
      perfil: '',
      permissions: []
    }
  },
  async mounted() {
    this.perfil = await getPerfil()
    this.permissions = await getPermissionsFromActualPerfil()
  },
  methods: {
    changeLanguage(lang) {
      Cookies.set('user_language', lang)
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  width: 15rem;
  height: 100vh;

  .nav-item {
    margin: 8px;
  }
}

/deep/ .nav-link {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  line-height: normal;
  position: relative;
  color: #1f2d41;

  &:hover {
    background-color: #eaecf4;
  }
}

.nav-link-icon {
  font-size: 0.9rem;
  padding-right: 0.5rem;
  display: -webkit-inline-box;
  display: inline-flex;
  color: #a2acba;
  margin-right: 0.5rem;
}

/deep/ .dropdown-item {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  padding: .5rem;
}

/deep/ .dropdown-menu {
  transform: none !important;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: #a2acba 1px solid !important;
}
</style>
